import { useEffect, useState } from 'react';
import { accumulatedFilterResults } from '../utils/filter-functions';

const useFilter = inputData => {
  const inputDataCopy = [...inputData];
  const [filteredData, setFilteredData] = useState(inputDataCopy);
  const [queryArray, updateQueryArray] = useState([]);
  const [compareFunctionConfig, setCompareFunctionConfig] = useState({});

  // @TODO move this to transformation layer!!!
  const getValue = (value, isNumber) => {
    if (isNumber) {
      let outputNumber = 0;
      if (value) {
        outputNumber = parseFloat(value);
      }
      return outputNumber;
    }
    return value.toLowerCase();
  };

  useEffect(() => {
    // first run all filters
    let results = accumulatedFilterResults(inputDataCopy, queryArray);

    if ('fieldName' in compareFunctionConfig) {
      results.sort((a, b) => {
        const fieldName = compareFunctionConfig.fieldName;
        let valueA = getValue(a[fieldName], compareFunctionConfig.isNumber);
        let valueB = getValue(b[fieldName], compareFunctionConfig.isNumber);
        let result;

        if (valueA > valueB) {
          result = 1;
        } else if (valueA < valueB) {
          result = -1;
        } else {
          return 0;
        }
        if (!compareFunctionConfig.isAscending) {
          result *= -1;
        }
        return result;
      });
    }
    setFilteredData(results);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryArray, compareFunctionConfig]);

  return {
    filteredData,
    updateQueryArray,
    setCompareFunctionConfig,
  };
};

export default useFilter;
